import * as t from "io-ts";

const IndustryIO = t.intersection([
  t.type({
    id: t.string,
    sic_code: t.string,
    industry: t.union([t.string, t.null]),
  }),
  t.partial({
    sub_industry: t.union([t.string, t.null]),
    category: t.union([t.array(t.string), t.string, t.null]),
    lsic_code: t.string,
    market_cap: t.string,
  }),
]);
export const AddressIO = t.type({
  full_address: t.union([t.string, t.null]),
  street: t.string,
  city: t.union([t.string, t.null]),
  state: t.union([t.string, t.null]),
  country: t.string,
  postal_code: t.union([t.string, t.null]),
  type: t.string,
});
export type AddressT = t.TypeOf<typeof AddressIO>;
export type IndustryT = t.TypeOf<typeof IndustryIO>;

const ShareAllotedIO = t.intersection([
  t.type({
    date: t.string,
    share_class: t.string,
    number_of_share: t.string,
  }),
  t.partial({
    type: t.string,
    share_holder: t.string,
    currency: t.string,
    aggregate_nominal_value: t.string,
    prescribed_class: t.string,
  }),
]);
export type ShareAllotedT = t.TypeOf<typeof ShareAllotedIO>;

const ManagementIO = t.intersection([
  t.type({
    name: t.string,
    email: t.string,
    phone: t.string,
    position: t.string,
    linkedin: t.string,
  }),
  t.partial({
    tags: t.array(t.string),
    description: t.string,
    profileImage: t.string,
    dob: t.string,
  }),
]);

export type ManagementT = t.TypeOf<typeof ManagementIO>;

export const UrlIO = t.type({
  website: t.string,
  logo: t.string,
  linkedin: t.string,
  twitter: t.string,
});
export type UrlT = t.TypeOf<typeof UrlIO>;

export const EmployeeCountIO = t.type({
  year: t.string,
  count: t.type({
    from: t.number,
    to: t.number,
  }),
});
export type EmployeeCountT = t.TypeOf<typeof EmployeeCountIO>;

export const FundingRoundIO = t.intersection([
  t.type({
    companyID: t.string,
    amount: t.number,
    currency: t.string,

    date: t.string,
    investorIDs: t.union([t.array(t.string), t.any]),
  }),
  t.partial({ stage: t.union([t.string, t.null]), fundingRoundID: t.string }),
]);

export type FundingRoundT = t.TypeOf<typeof FundingRoundIO>;

export const FinancialIO = t.intersection([
  t.type({
    companyID: t.string,
    date: t.string,
  }),
  t.partial({
    financialID: t.string,
    revenue: t.number,
    cogs: t.number,
    operatingExpenses: t.number,
    netProfit: t.number,
    cashFlow: t.number,
    assets: t.number,
    liabilities: t.number,
    equity: t.number,
    currency: t.string,
  }),
]);

export type FinancialT = t.TypeOf<typeof FinancialIO>;
export const TractionIO = t.intersection([
  t.type({
    description: t.string,
  }),
  t.partial({
    date: t.string,
    source: t.string,
    sourceURL: t.string,
  }),
]);
export type TractionT = t.TypeOf<typeof TractionIO>;
export const CompanyIO = t.intersection([
  t.type({
    name: t.string,
    incorporation_date: t.string,
    companyID: t.string,
    status: t.string,
  }),
  t.partial({
    description: t.string,
    business_description: t.string,
    traction: t.array(TractionIO),
    licence_no: t.union([t.string, t.null]),
    tags: t.array(t.string),
    industry: IndustryIO,
    url: UrlIO,
    funding_rounds: t.array(FundingRoundIO),
    financials: t.array(FinancialIO),
    emp_count: t.array(EmployeeCountIO),
    management: t.array(ManagementIO),
    share_allotment: t.partial({
      cs01: t.array(ShareAllotedIO),
      sh01: t.array(ShareAllotedIO),
    }),
    address: t.array(AddressIO),
    company_type: t.string,
    badges: t.array(t.union([t.string, t.null])),
  }),
]);

export const CompaniesIO = t.array(CompanyIO);

export type CompanyType = t.TypeOf<typeof CompanyIO>;

export default CompanyIO;

// TODO:: Need to remove from here
// export const AccumulatedFundingIO = t.type({
//   fundedAmount: t.number,
//   fundingRounds: t.number,
//   mostFundedStage: t.string,
//   companyCount: t.number,
//   formatted: t.type({
//     companyCount: t.string,
//     fundedAmount: t.string,
//   }),
// });
// export type AccumulatedFundingT = t.TypeOf<typeof AccumulatedFundingIO>;

export const FundingTrendIO = t.type({
  totalAmount: t.number,
  month: t.number,
  year: t.number,
  monthLabel: t.string,
});
export const FundingTrendsIO = t.array(FundingTrendIO);
export type FundingTrendT = t.TypeOf<typeof FundingTrendIO>;

export const MegaDealCompanyIO = t.type({
  companyID: t.string,
  name: t.string,
  url: UrlIO,
  totalFunding: t.number,
});

export const MegaDealCompaniesIO = t.array(MegaDealCompanyIO);
export type MegaDealCompanyT = t.TypeOf<typeof MegaDealCompanyIO>;

export const DealByStageIO = t.type({
  stage: t.string,
  totalAmount: t.number,
  occurance: t.number,
});

export const DealByStagesIO = t.array(DealByStageIO);
export type DealByStageT = t.TypeOf<typeof DealByStageIO>;
